import create from './../organisations/create'

export default {
    create
}